module.exports = __webpack_public_path__ + "bc2e8c86ef32fb902be83cb6a0cb4ff5.png";